export enum DrinkFrequency {
  Never,
  Monthly,
  TwiceMonthly,
  Weekly
}

export type DrinkFrequencyIndexer<T> = {
  [id in DrinkFrequency]: T;
};
